import { createContext } from 'react';

import { IBurgerContext, defaultBurgerState } from '@app/objects/BurgerContext';
import { defaultPixelContextState, IPixelContext } from '@app/objects/PixelContext';

export const BurgerContext = createContext<IBurgerContext>(defaultBurgerState);

export const PixelContext = createContext<IPixelContext>(defaultPixelContextState);
